import { Crop } from 'react-image-crop';

import { FreelancerAccessErrorTypes } from '../../service/FreelancerAccessError';
import {
    FreelancerAvatar,
    FreelancerCardEditData,
    FreelancerCardEditImageData,
    FreelancerCardInitRegion,
    FreelancerContactTypes,
    FreelancersCertificates
} from '../../typings/freelancers';
import { FreelancerServiceFragment } from '../../typings/graphql-grid';
import { RegionInputIds } from '../../typings/regions';

export const UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO = 'UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO';
export type UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO = typeof UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO;

export const UPDATE_FREELANCER_CARD_EDIT_CONTACT = 'UPDATE_FREELANCER_CARD_EDIT_CONTACT';
export type UPDATE_FREELANCER_CARD_EDIT_CONTACT = typeof UPDATE_FREELANCER_CARD_EDIT_CONTACT;

export const UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE = 'UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE';
export type UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE = typeof UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE;

export const UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION = 'UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION';
export type UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION = typeof UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION;

export const ADD_FREELANCER_CARD_EDIT_SERVICE = 'ADD_FREELANCER_CARD_EDIT_SERVICE';
export type ADD_FREELANCER_CARD_EDIT_SERVICE = typeof ADD_FREELANCER_CARD_EDIT_SERVICE;

export const DELETE_FREELANCER_CARD_EDIT_SERVICE = 'DELETE_FREELANCER_CARD_EDIT_SERVICE';
export type DELETE_FREELANCER_CARD_EDIT_SERVICE = typeof DELETE_FREELANCER_CARD_EDIT_SERVICE;

export const VALIDATE_FREELANCER_CARD_EDIT = 'VALIDATE_FREELANCER_CARD_EDIT';
export type VALIDATE_FREELANCER_CARD_EDIT = typeof VALIDATE_FREELANCER_CARD_EDIT;

export const FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE = 'FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE';
export type FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE = typeof FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE;

export const FETCH_INITIAL_FREELANCER_DATA = 'FETCH_INITIAL_FREELANCER_DATA';
export type FETCH_INITIAL_FREELANCER_DATA = typeof FETCH_INITIAL_FREELANCER_DATA;

export const UPDATE_INITIAL_FREELANCER_DATA = 'UPDATE_INITIAL_FREELANCER_DATA';
export type UPDATE_INITIAL_FREELANCER_DATA = typeof UPDATE_INITIAL_FREELANCER_DATA;

export const SET_INITIAL_FREELANCER_DATA_ERROR = 'SET_INITIAL_FREELANCER_DATA_ERROR';
export type SET_INITIAL_FREELANCER_DATA_ERROR = typeof SET_INITIAL_FREELANCER_DATA_ERROR;

export const SAVE_FREELANCER_DATA = 'SAVE_FREELANCER_DATA';
export type SAVE_FREELANCER_DATA = typeof SAVE_FREELANCER_DATA;

export const CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP = 'CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP';
export type CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP = typeof CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP;

export const SET_FREELANCER_CARD_EDIT_IMAGE_DATA = 'SET_FREELANCER_CARD_EDIT_IMAGE_DATA';
export type SET_FREELANCER_CARD_EDIT_IMAGE_DATA = typeof SET_FREELANCER_CARD_EDIT_IMAGE_DATA;

export const SET_FREELANCER_CARD_EDIT_IMAGE_CROP = 'SET_FREELANCER_CARD_EDIT_IMAGE_CROP';
export type SET_FREELANCER_CARD_EDIT_IMAGE_CROP = typeof SET_FREELANCER_CARD_EDIT_IMAGE_CROP;

export const FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START = 'FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START';
export type FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START = typeof FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START;

export const FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS = 'FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS';
export type FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS = typeof FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS;

export const FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR = 'FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR';
export type FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR = typeof FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR;

export const FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START = 'FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START';
export type FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START = typeof FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START;

export const FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS = 'FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS';
export type FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS = typeof FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS;

export const FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR = 'FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR';
export type FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR = typeof FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR;

export const VALIDATE_FREELANCER_CARD_EDIT_REGION = 'VALIDATE_FREELANCER_CARD_EDIT_REGION';
export type VALIDATE_FREELANCER_CARD_EDIT_REGION = typeof VALIDATE_FREELANCER_CARD_EDIT_REGION;

export const FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS = 'FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS';
export type FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS = typeof FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS;

export interface UpdateFreelancerCardEditBriefInfoAction {
    type: UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO;
    value: string;
}

export interface ValidateFreelancerCardEditRegionAction {
    type: VALIDATE_FREELANCER_CARD_EDIT_REGION;
    regionInputId: RegionInputIds;
}

export interface UpdateFreelancerCardEditContactAction {
    type: UPDATE_FREELANCER_CARD_EDIT_CONTACT;
    key: FreelancerContactTypes;
    value?: string;
}

export interface UpdateFreelancerCardEditServicePriceAction {
    type: UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE;
    idx: number;
    value: string;
}

export interface UpdateFreelancerCardEditServiceDurationAction {
    type: UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION;
    idx: number;
    value: string;
}

export interface AddFreelancerCardEditServiceAction {
    type: ADD_FREELANCER_CARD_EDIT_SERVICE;
    skillId: string;
}

export interface DeleteFreelancerCardEditServiceAction {
    type: DELETE_FREELANCER_CARD_EDIT_SERVICE;
    idx: number;
}

export interface ValidateFreelancerCardEditAction {
    type: VALIDATE_FREELANCER_CARD_EDIT;
    freelancerRegionHasError: boolean;
}

export interface FormatFreelancerCardEditServicePriceAction {
    type: FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE;
    idx: number;
}

export interface FetchInitialFreelancerDataAction {
    type: FETCH_INITIAL_FREELANCER_DATA;
    login: string;
    regionInputId: RegionInputIds;
}

export interface UpdateInitialFreelancerDataAction {
    type: UPDATE_INITIAL_FREELANCER_DATA;
    payload: {
        editData: FreelancerCardEditData;
        servicesList: FreelancerServiceFragment[];
        certificates: FreelancersCertificates[];
        initRegion: FreelancerCardInitRegion;
        regionInputId: RegionInputIds;
    };
}

export interface SetInitialFreelancerDataErrorAction {
    type: SET_INITIAL_FREELANCER_DATA_ERROR;
    errorType: FreelancerAccessErrorTypes;
}

export interface SaveFreelancerDataAction {
    type: SAVE_FREELANCER_DATA;
    regionInputId: RegionInputIds;
}

export interface CloseFreelancerCardEditImagePopupAction {
    type: CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP;
}

export interface SetFreelancerCardEditImageDataAction {
    type: SET_FREELANCER_CARD_EDIT_IMAGE_DATA;
    payload: FreelancerCardEditImageData;
}

export interface SetFreelancerCardEditImageCropAction {
    type: SET_FREELANCER_CARD_EDIT_IMAGE_CROP;
    payload?: Crop;
}

export interface FreelancerCardEditImageUploadStartAction {
    type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START;
    login: string;
    blob: Blob;
}

export interface FreelancerCardEditImageUploadSuccessAction {
    type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS;
    payload: FreelancerAvatar;
}

export interface FreelancerCardEditImageUploadErrorAction {
    type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR;
}

export interface FreelancerCardEditImageUploadLocalStartAction {
    type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START;
}

export interface FreelancerCardEditImageUploadLocalSuccessAction {
    type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS;
}

export interface FreelancerCardEditImageUploadLocalErrorAction {
    type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR;
    messageError: string;
}

export interface FreelancerCardEditSetSaveProgressStatusAction {
    type: FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS;
    value: boolean;
}

export function updateFreelancerCardEditBriefInfo(value: string): UpdateFreelancerCardEditBriefInfoAction {
    return {
        type: UPDATE_FREELANCER_CARD_EDIT_BRIEF_INFO,
        value
    };
}

export function updateFreelancerCardEditContact(
    key: FreelancerContactTypes,
    value?: string
): UpdateFreelancerCardEditContactAction {
    return {
        type: UPDATE_FREELANCER_CARD_EDIT_CONTACT,
        key,
        value
    };
}

export function updateFreelancerCardEditServicePrice(
    idx: number,
    value: string
): UpdateFreelancerCardEditServicePriceAction {
    return {
        type: UPDATE_FREELANCER_CARD_EDIT_SERVICE_PRICE,
        idx,
        value
    };
}

export function updateFreelancerCardEditServiceDuration(
    idx: number,
    value: string
): UpdateFreelancerCardEditServiceDurationAction {
    return {
        type: UPDATE_FREELANCER_CARD_EDIT_SERVICE_DURATION,
        idx,
        value
    };
}

export function addFreelancerCardEditService(skillId: string): AddFreelancerCardEditServiceAction {
    return {
        type: ADD_FREELANCER_CARD_EDIT_SERVICE,
        skillId
    };
}

export function deleteFreelancerCardEditService(idx: number): DeleteFreelancerCardEditServiceAction {
    return {
        type: DELETE_FREELANCER_CARD_EDIT_SERVICE,
        idx
    };
}

export function validateFreelancerCardEdit(freelancerRegionHasError: boolean): ValidateFreelancerCardEditAction {
    return {
        type: VALIDATE_FREELANCER_CARD_EDIT,
        freelancerRegionHasError
    };
}

export function formatFreelancerCardEditServicePrice(idx: number): FormatFreelancerCardEditServicePriceAction {
    return {
        type: FORMAT_FREELANCER_CARD_EDIT_SERVICE_PRICE,
        idx
    };
}

export function validateFreelancerCardEditRegion(
    regionInputId: RegionInputIds
): ValidateFreelancerCardEditRegionAction {
    return {
        type: VALIDATE_FREELANCER_CARD_EDIT_REGION,
        regionInputId
    };
}

export function fetchInitialFreelancerData(
    login: string,
    regionInputId: RegionInputIds
): FetchInitialFreelancerDataAction {
    return {
        type: FETCH_INITIAL_FREELANCER_DATA,
        login,
        regionInputId
    };
}

export function updateInitialFreelancerData(
    editData: FreelancerCardEditData,
    servicesList: FreelancerServiceFragment[],
    certificates: FreelancersCertificates[],
    initRegion: FreelancerCardInitRegion,
    regionInputId: RegionInputIds
): UpdateInitialFreelancerDataAction {
    return {
        type: UPDATE_INITIAL_FREELANCER_DATA,
        payload: {
            editData,
            servicesList,
            certificates,
            initRegion,
            regionInputId
        }
    };
}

export function setInitialFreelancerDataError(
    errorType: FreelancerAccessErrorTypes
): SetInitialFreelancerDataErrorAction {
    return {
        type: SET_INITIAL_FREELANCER_DATA_ERROR,
        errorType
    };
}

export function saveFreelancerData(regionInputId: RegionInputIds): SaveFreelancerDataAction {
    return {
        type: SAVE_FREELANCER_DATA,
        regionInputId
    };
}

export function closeFreelancerCardEditImagePopup(): CloseFreelancerCardEditImagePopupAction {
    return {
        type: CLOSE_FREELANCER_CARD_EDIT_IMAGE_POPUP
    };
}

export function setFreelancerCardEditImageData(
    payload: FreelancerCardEditImageData
): SetFreelancerCardEditImageDataAction {
    return {
        type: SET_FREELANCER_CARD_EDIT_IMAGE_DATA,
        payload
    };
}

export function setFreelancerCardEditImageCrop(payload?: Crop): SetFreelancerCardEditImageCropAction {
    return {
        type: SET_FREELANCER_CARD_EDIT_IMAGE_CROP,
        payload
    };
}

export function freelancerCardEditImageUploadStart(
    login: string,
    blob: Blob
): FreelancerCardEditImageUploadStartAction {
    return {
        type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_START,
        login,
        blob
    };
}

export function freelancerCardEditImageUploadSuccess(
    payload: FreelancerAvatar
): FreelancerCardEditImageUploadSuccessAction {
    return {
        type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_SUCCESS,
        payload
    };
}

export function freelancerCardEditImageUploadError(): FreelancerCardEditImageUploadErrorAction {
    return {
        type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_ERROR
    };
}

export function feelancerCardEditImageUploadLocalStart(): FreelancerCardEditImageUploadLocalStartAction {
    return {
        type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_START
    };
}

export function freelancerCardEditImageUploadLocalSuccess(): FreelancerCardEditImageUploadLocalSuccessAction {
    return {
        type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_SUCCESS
    };
}

export function freelancerCardEditImageUploadLocalError(
    messageError: string
): FreelancerCardEditImageUploadLocalErrorAction {
    return {
        type: FREELANCER_CARD_EDIT_IMAGE_UPLOAD_LOCAL_ERROR,
        messageError
    };
}

export function freelancerCardEditSetSaveProgressStatus(value: boolean): FreelancerCardEditSetSaveProgressStatusAction {
    return {
        type: FREELANCER_CARD_EDIT_SET_SAVE_PROGRESS_STATUS,
        value
    };
}

export type FreelancerCardEditAction =
    | UpdateFreelancerCardEditBriefInfoAction
    | UpdateFreelancerCardEditContactAction
    | UpdateFreelancerCardEditServicePriceAction
    | UpdateFreelancerCardEditServiceDurationAction
    | AddFreelancerCardEditServiceAction
    | DeleteFreelancerCardEditServiceAction
    | ValidateFreelancerCardEditAction
    | FormatFreelancerCardEditServicePriceAction
    | ValidateFreelancerCardEditRegionAction
    | FetchInitialFreelancerDataAction
    | UpdateInitialFreelancerDataAction
    | SetInitialFreelancerDataErrorAction
    | SaveFreelancerDataAction
    | CloseFreelancerCardEditImagePopupAction
    | SetFreelancerCardEditImageDataAction
    | SetFreelancerCardEditImageCropAction
    | FreelancerCardEditImageUploadStartAction
    | FreelancerCardEditImageUploadSuccessAction
    | FreelancerCardEditImageUploadErrorAction
    | FreelancerCardEditImageUploadLocalStartAction
    | FreelancerCardEditImageUploadLocalSuccessAction
    | FreelancerCardEditImageUploadLocalErrorAction
    | FreelancerCardEditSetSaveProgressStatusAction;
